

























































































import { Component, Mixins, Prop, Watch } from "vue-property-decorator"
import QuestionMixins from "@/mixins/QuestionMixins"
import { mapState, mapMutations } from "vuex"
import BookingReportInfo from "./Report/BookingReportInfo.vue"
import BookingReportCandidateInfo from "./Report/BookingReportCandidateInfo.vue"
import BookingReportBodyMaps from "./Report/BookingReportBodyMaps.vue"
import BookingReportRiskProfileItems from "./Report/BookingReportRiskProfileItems.vue"
import BookingReportQuestions from "./Report/BookingReportQuestions.vue"
import BookingReportCandidateProfileQuestions from "./Report/BookingReportCandidateProfileQuestions.vue"
import BookingReportHeader from "./Report/partials/BookingReportHeader.vue"
import BookingReportDoctorAssessorComments from "./Report/BookingReportDoctorAssessorComments.vue"
import BookingReportDefinition from "./Report/BookingReportDefinition.vue"

@Component({
  components: {
    "component-candidate-response": BookingReportQuestions,
    "component-candidate-profile": BookingReportCandidateProfileQuestions,
    "component-information": BookingReportInfo,
    "component-candidate-information": BookingReportCandidateInfo,
    "component-body-maps": BookingReportBodyMaps,
    "component-risk-profiles": BookingReportRiskProfileItems,
    'component-doctor-assessor-comments': BookingReportDoctorAssessorComments,
    'component-definition': BookingReportDefinition,
    BookingReportHeader,
  },
  computed: {
    ...mapState("QuestionnaireAnswer", {
      report: "report",
      onboarding: "onboarding"
    }),
  },
  methods: {
    ...mapMutations("QuestionnaireAnswer", {
      nextReportPage: 'NEXT_REPORT_PAGE',
      prevReportPage: 'PREV_REPORT_PAGE',
      setReportPage: 'SET_REPORT_PAGE'
    })
  }
})
export default class BookingReadReport extends Mixins(QuestionMixins) {
  @Prop() readonly questionnaireAnswerOid!: string
  @Prop({ default: false }) readonly isForPreview!: boolean

  isMounted = false

  report!: any
  onboarding!: number
  nextReportPage!: () => void
  prevReportPage!: () => void
  setReportPage!: (v: number) => void

  isApiFetch = {
    isApiFetchQuestionnaireAnswerFinished: false,
  }

  showTips = false

  async beforeMount() {
    await this.fetchQuestionnaire()
  }

  get page() {
    return this.onboarding
  }
  set page(v) {
    this.setReportPage(v)
  }

  @Watch("isApiFetch", { deep: true })
  watchIsApiFetch(newVal) {
    if (newVal) {
      let isFinished = true
      for (const [key, value] of Object.entries(this.isApiFetch)) {
        if (!value) {
          isFinished = false
        }
      }
      if (isFinished) {
        this.isMounted = true
      }
    }
  }

  async fetchQuestionnaire() {
    let questionnaireAnswerOid = this.questionnaireAnswerOid
    let action = "QuestionnaireAnswer/fetchResult"
    
    if (! this.questionnaireAnswerOid) {
      questionnaireAnswerOid = this.$route.params.questionnaireAnswerOid
    }

    if (this.isForPreview) {
      action = "QuestionnaireAnswer/fetchResultForPreview"
    }

    await this.$store
      .dispatch(action, questionnaireAnswerOid)
      .then(() => {
        this.isApiFetch["isApiFetchQuestionnaireAnswerFinished"] = true
      })
  }
}
